import React from 'react'
import './OurVision.css';
function OurVision() {
    return (
        <div className='our-vision'>
            <div className='our-vision-wrapper'>
                <h2>Our Vision</h2>
                <p className='our-vision-p1'>"To build a prosperous, inclusive, and sustainable community where every resident enjoys a high quality of life, empowered with opportunities for growth and development."</p>
            </div>
        </div>
    )
}

export default OurVision